export const MY_SAVED_ITEMS_PAGE_SIZE = 12;